import WordCreate from './views/WordCreate.vue';
import WordList from './views/WordList.vue';
import Word from './Root.vue';
import WordListImport from './views/WordListImport.vue';
import WordImport from './views/WordImport.vue';

export default {
  path: 'palavra/',
  component: Word,
  name: 'admin-word',
  redirect: '/palavras/novo',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-word-list',
      component: WordList,
    },
    {
      path: 'importacao/lista/:page',
      name: 'admin-word-list-import',
      component: WordListImport,
    },
    {
      path: 'importacao/novo',
      name: 'admin-word-import-new',
      component: WordImport,
    },
    {
      path: 'novo',
      name: 'admin-word-new',
      component: WordCreate,
    },
  ],
};
